import { SidebarState } from './types';

export function initialState(): SidebarState {
  return {
    isOpen: false,
  };
}
